<template>
  <div class="animate-pulse">
    <div class="flex flex-col md:flex-row items-center gap-4 mb-6">
      <div class="w-[327px] h-[40px] bg-slate-200 rounded shrink-0"></div>
      <div class="h-[40px] w-[90px] bg-slate-200 rounded-full"></div>
      <div class="ml-auto h-[40px] w-[160px] bg-slate-200 rounded"></div>
    </div>

    <div class="overflow-x-auto rounded-lg shadow-sm border border-gray-200 min-h-[300px]">
      <div
        class="hidden md:grid gap-2 px-4 py-2"
        style="
          grid-template-columns: auto minmax(150px, 1fr) minmax(150px, 1fr) minmax(150px, 1fr) auto;
          background: #fafafa;
        "
      >
        <div class="px-2"><div class="h-4 w-6 bg-slate-200 rounded"></div></div>
        <div class="px-2"><div class="h-4 w-32 bg-slate-200 rounded"></div></div>
        <div class="px-2"><div class="h-4 w-20 bg-slate-200 rounded"></div></div>
        <div class="px-2"><div class="h-4 w-24 bg-slate-200 rounded"></div></div>
        <div class="px-2"><div class="h-4 w-12 bg-slate-200 rounded"></div></div>
      </div>

      <div class="flex flex-col">
        <div
          v-for="n in 5"
          :key="n"
          class="grid gap-2 items-center py-4 px-4 border-b border-gray-100"
          style="
            grid-template-columns:
              auto minmax(150px, 1fr) minmax(150px, 1fr) minmax(150px, 1fr)
              auto;
          "
        >
          <div class="flex items-center justify-center px-2">
            <div class="h-6 w-14 bg-slate-200 rounded-full"></div>
          </div>
          <div class="flex items-center px-2">
            <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
          </div>
          <div class="flex items-center px-2">
            <div class="h-4 w-1/2 bg-slate-200 rounded"></div>
          </div>
          <div class="flex items-center px-2">
            <div class="h-4 w-24 bg-slate-200 rounded"></div>
          </div>
          <div class="flex items-center gap-2 px-2">
            <div class="h-8 w-8 bg-slate-200 rounded"></div>
            <div class="h-8 w-8 bg-slate-200 rounded"></div>
            <div class="h-6 w-12 bg-slate-200 rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
